var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "treeBox", staticClass: "custom-tree" },
    [
      _c("vxe-list", {
        staticClass: "custom-tree__row",
        attrs: {
          height: "300",
          "auto-resize": "",
          loading: false,
          data: _vm.options
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var items = ref.items
              return _vm._l(items, function(item) {
                return _c(
                  "div",
                  {
                    key: item[_vm.props.id],
                    staticClass: "custom-tree__row",
                    class: [
                      "leaf-" + item.level,
                      { "has-child": item.haveChild, "is-expand": item.expand },
                      {
                        "custom-tree__active":
                          !_vm.showCheckbox &&
                          _vm.checkedItem &&
                          _vm.checkedItem[_vm.props.id] === item[_vm.props.id]
                      }
                    ],
                    style: { paddingLeft: item.level * 10 + "px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.show,
                            expression: "item.show"
                          }
                        ]
                      },
                      [
                        !!item.haveChild
                          ? _c("i", {
                              class: {
                                "el-icon-caret-bottom": item.expand,
                                "el-icon-caret-right": !item.expand
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTreeNode(item)
                                }
                              }
                            })
                          : _c("i", { staticClass: "el-icon__empty" }),
                        _vm._v(" "),
                        _vm.showCheckbox
                          ? _c("el-checkbox", {
                              attrs: { disabled: item.readonly },
                              on: {
                                change: function($event) {
                                  return _vm.checkChange(item)
                                }
                              },
                              model: {
                                value: item.checked,
                                callback: function($$v) {
                                  _vm.$set(item, "checked", $$v)
                                },
                                expression: "item.checked"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "custom-tree__label",
                            class: {
                              "custom-tree__delete": item.Status === -1,
                              "custom-tree__disabled": item.readonly
                            },
                            on: {
                              click: function($event) {
                                return _vm.checkChange(item, true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.getLabel(item)))]
                        )
                      ],
                      1
                    )
                  ]
                )
              })
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9229d82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9229d82","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customTree.vue
// module id = null
// module chunks = 